import React from 'react';
import 'twin.macro';
import { SwitchToggle } from 'components/Form/SwitchToggle';
import Input from 'components/Form/InputGroup';
import Button from 'components/Buttons/Button';
import { XMarkIcon as X } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

interface Props {
  value: string | null;
  onChange: (v: string | null) => void;
}

export function Decloisonnement(props: Props) {
  const { value, onChange } = props;
  const inputRef = React.useRef<HTMLInputElement>(null);
  const isDecloisonnement = value !== null;
  const { t } = useTranslation(['eleve', 'common']);
  const label = t('eleve:fields.eleveDecloisonnement');
  return (
    <>
      <div tw="mr-2">
        {!isDecloisonnement && (
          <SwitchToggle
            size="sm"
            label={label}
            onChange={() => {
              if (isDecloisonnement) {
                return onChange(null);
              }
              onChange('');
              return setTimeout(() => {
                inputRef.current?.focus();
              }, 100);
            }}
            checked={isDecloisonnement}
          />
        )}
      </div>
      {isDecloisonnement && (
        <div tw="flex gap-x-2 items-end">
          <Input
            withoutMargin
            inputRef={inputRef}
            label={label}
            value={value}
            onChange={e => onChange(e)}
          />
          <div>
            <Button onClick={() => onChange(null)} minimal icon={X} />
          </div>
        </div>
      )}
    </>
  );
}
